import type {
    InputHTMLAttributes,
    ReactNode,
    SelectHTMLAttributes,
    TextareaHTMLAttributes,
} from 'react'

const controlClass =
    'w-full rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 transition-colors placeholder:text-slate-400 dark:placeholder:text-slate-500 hover:border-slate-400 dark:hover:border-slate-500 focus:border-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600/20 disabled:bg-slate-100 dark:disabled:bg-slate-800 disabled:text-slate-500 dark:disabled:text-slate-400 disabled:hover:border-slate-300 dark:disabled:hover:border-slate-600'

export function Field({
    label,
    children,
    className = '',
}: {
    label: string
    children: ReactNode
    className?: string
}) {
    return (
        <label className={`block ${className}`}>
            <span className='mb-1 block text-xs font-medium text-slate-600 dark:text-slate-300'>
                {label}
            </span>
            {children}
        </label>
    )
}

export function Input({
    className = '',
    ...rest
}: InputHTMLAttributes<HTMLInputElement>) {
    return <input className={`${controlClass} ${className}`} {...rest} />
}

export function Textarea({
    className = '',
    ...rest
}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
    return (
        <textarea className={`${controlClass} min-h-20 ${className}`} {...rest} />
    )
}

export function Select({
    className = '',
    children,
    ...rest
}: SelectHTMLAttributes<HTMLSelectElement>) {
    return (
        <select
            className={`${controlClass} select-caret cursor-pointer ${className}`}
            {...rest}
        >
            {children}
        </select>
    )
}
